import React from 'react';
import { Alert, Button, Modal, Spin, Tag, Tooltip, Typography } from 'antd';
import {
  AzureOnboardingRediscoverResult,
  AzureOnboardingScopeRef,
} from '../../../../services/azure/azureOnboarding/azureOnboarding.model';
import { CoveredButActiveAlert, ScopeRefList } from './ScopeRefList';

const { Text } = Typography;

export interface RediscoverState {
  title: string;
  loading: boolean;
  result?: AzureOnboardingRediscoverResult;
  error?: string;
}

const RediscoverResultModal: React.FC<{ state: RediscoverState; onClose: () => void }> = ({
  state,
  onClose,
}) => {
  const { result } = state;
  const scopes = result?.scopes ?? [];

  const renderActive = (ref: AzureOnboardingScopeRef) => {
    const added = result?.added.find((a) => a.id === ref.id);
    return added?.active ? (
      <Tag color="success">on</Tag>
    ) : (
      <Tooltip title="Non-CSP subscription, saved switched off">
        <Tag>off</Tag>
      </Tooltip>
    );
  };

  return (
    <Modal
      wrapClassName="custom-modal"
      title={state.title}
      centered
      visible
      onCancel={onClose}
      footer={null}
      width={720}
    >
      <Spin spinning={state.loading}>
        {state.error && <Alert type="error" showIcon message={state.error} />}
        {result && (
          <>
            {result.message && (
              <Alert type="info" showIcon message={result.message} style={{ marginBottom: 16 }} />
            )}
            <div className="form-group">
              <Text strong>Discovered in Azure:</Text> {result.discovered_count}
            </div>
            {result.added.length > 0 && (
              <div className="form-group">
                <Text strong>Added</Text>
                <ScopeRefList refs={result.added} scopes={scopes} renderExtra={renderActive} />
              </div>
            )}
            {result.deactivated.length > 0 && (
              <div className="form-group">
                <Text strong>Deactivated</Text>{' '}
                <Text type="secondary">
                  (switched off because a newly found billing account bills it)
                </Text>
                <ScopeRefList refs={result.deactivated} scopes={scopes} />
              </div>
            )}
            <CoveredButActiveAlert refs={result.covered_but_active} scopes={scopes} />
          </>
        )}
      </Spin>
      <div className="btns-block modal-footer">
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default RediscoverResultModal;
